import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core'
import { ButtonBase } from './button.base'

/**
 * Base button component, primarily used for displaying clickable text within a coloured border.
 *
 * For buttons that display only an icon, use {@link IconButtonComponent}. For buttons that appear
 * as text, use {@link TertiaryButtonComponent}. For smaller, understated buttons with limited
 * space, use {@link SubtleButtonComponent}.
 *
 * @example
 * ``` html
 * <button
 *   ftrButton
 *   color="secondary"
 *   size="small"
 *   class="custom-class"
 *   [disabled]="someBoolean"
 *   (click)="doSomething($event)"
 * >
 *   Click me!
 * </button>
 * ```
 */
@Component({
  standalone: true,
  selector: 'button[ftrButton]',
  styleUrls: ['./button.component.css'],
  template: '<ng-content></ng-content>',
  exportAs: 'ftrButton',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ButtonComponent extends ButtonBase {}
